import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";
import { WFDashboardIssuePerStatusResponseDto } from '../../../data-transfer-objects/wf';


@Injectable({ providedIn: 'root' })
export class DashboardIssuesPerStatusReport extends BaseApiTemplateService<WFDashboardIssuePerStatusResponseDto> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'dashboard/issue-per-status-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + 'dashboard/issue-per-status-report';
    this.httpClient = theHttp;
    }

    getIssuePerStatusReport(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<WFDashboardIssuePerStatusResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<WFDashboardIssuePerStatusResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }
}